import { useMutation } from '@tanstack/react-query';
import publicAxiosInstance from '../../../../constants/publicAxiosInstance';
import { toast } from 'react-toastify';

interface VerifyInvitedUserOtpResponse {
  status?: boolean;
  isPhoneNumberVerified?: boolean;
  message: string;
  data?: any;
}

interface VerifyInvitedUserOtpParams {
  userId: string;
  verificationId: string;
  otp: string;
}

const verifyInvitedUserOtp = async (params: VerifyInvitedUserOtpParams): Promise<VerifyInvitedUserOtpResponse> => {
  const { data } = await publicAxiosInstance().post<VerifyInvitedUserOtpResponse>(
    '/newUsers/verifyOTPAndUpdateForInvitedUserVerification',
    params
  );
  return data;
};

export const useVerifyInvitedUserOtp = () => {
  return useMutation({
    mutationFn: verifyInvitedUserOtp,
    onSuccess: (data) => {
      // Check if message indicates success
      if (data.status && data.isPhoneNumberVerified) {
        toast.success(data.message || 'Phone number verified & updated successfully');
      } else {
        toast.error(data.message || 'OTP verification failed');
      }
    },
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to verify OTP. Please try again.');
    },
  });
};
